module.exports = __webpack_public_path__ + "static/media/Play.40f7c32b.svg";